export default class LocalDate {
    drMonthName = {
        "1": "حمل",
        "2": "ثور",
        "3": "جوزا",
        "4": "سرطان",
        "5": "اسد",
        "6": "سنبله",
        "7": "میزان",
        "8": "عقرب",
        "9": "قوس",
        "10": "جدی",
        "11": "دلو",
        "12": "حوت"
    };

    psMonthName = {
        "1": "وری",
        "2": "غویی",
        "3": "غبرګلی",
        "4": "چنګاښ",
        "5": "زمری",
        "6": "وږی",
        "7": "تله",
        "8": "لړم",
        "9": "لیند",
        "10": "مرغومی",
        "11": "سلواغه",
        "12": "کب"
    };

    localDate = "";
    localYear = "";
    localMonth = "";
    localMonthName = "";
    localMonthNameShort = "";

    constructor(date = Date.now(), locale = "en") {
        let rowDate = new Date(date);

        if (locale !== "en") this.localDate = rowDate.toLocaleDateString("ps");
        else this.localDate = rowDate.toISOString().split('T')[0];

        this.localYear = rowDate.toLocaleDateString(
            locale === "dr" ? "ps" : locale,
            { year: "numeric" }
        );


        this.localMonth = rowDate.toLocaleDateString(
            locale === "dr" ? "ps" : locale,
            { month: "numeric" }
        );

        if (locale !== "en") {
            this.localMonthName = this[`${locale}MonthName`][this.localMonth];
            this.localMonthNameShort = this[`${locale}MonthName`][this.localMonth];
        } else {
            this.localMonthName = rowDate.toLocaleDateString(locale, {
                month: "long"
            });
            this.localMonthNameShort = rowDate.toLocaleDateString(locale, {
                month: "short"
            });
        }

        this.localTime = rowDate.toLocaleTimeString(locale == 'dr' ? 'ps' : locale, { minute: 'numeric', hour: 'numeric', hour12: true });
    }

    getDate() {
        return this.localDate;
    }

    getYear() {
        return this.localYear;
    }

    getMonth() {
        return this.localMonth;
    }

    getMonthName() {
        return this.localMonthName;
    }

    getMonthNameShort() {
        return this.localMonthNameShort;
    }

    getTime() {
        return this.localTime;
    }

    getDateTime() {
        return `${this.localDate} - ${this.localTime}`;
    }
}